module.exports = "/images/rating-stars.svg?82bedea55031b2dac4be9d962070d69e";